const BankAccounts = () => import('./BankAccounts.vue')
const BankAccountDialog = () => import('./BankAccountDialog.vue')
const BankAccountDetails = () => import('./BankAccountDetails.vue')

export default [
  {
    name: 'bank-accounts',
    path: 'bank-accounts',
    component: BankAccounts,
    meta: {
      access: ['org.finance.bankAccount.view']
    },
    children: [
      {
        name: 'bank-account-edit',
        path: ':bankAccountId/edit',
        components: {
          modal: BankAccountDialog
        },
        meta: {
          showModal: true,
          access: ['org.finance.bankAccount.manage']
        }
      },
      {
        name: 'bank-account-new',
        path: 'new',
        components: {
          modal: BankAccountDialog
        },
        meta: {
          showModal: true,
          access: ['org.finance.bankAccount.manage']
        }
      }
    ]
  },
  {
    name: 'bank-account',
    path: 'bank-account/:bankAccountId',
    component: BankAccountDetails,
    meta: {
      access: ['org.finance.bankAccount.view']
    }
  }
]
